// useScreenSize.ts - Improved version
import { useState, useEffect } from 'react';

type ScreenSize = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isPortrait: boolean;
};

export const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isPortrait: false
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      // Apple device detection
      const isApple = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isPortrait = height > width;

      setScreenSize({
        isMobile: width < 768 || (isApple && isPortrait),
        isTablet: (width >= 768 && width < 1024) || (isApple && !isPortrait),
        isDesktop: width >= 1024 && !isApple,
        isPortrait
      });
    };

    // Throttle resize events
    let timeout: NodeJS.Timeout;
    const throttledResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(handleResize, 100);
    };

    handleResize(); // Initial call
    window.addEventListener('resize', throttledResize);
    
    return () => {
      window.removeEventListener('resize', throttledResize);
      clearTimeout(timeout);
    };
  }, []);

  return screenSize;
};